import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, callbackFinally) => {
    return AppModel.get(
      '/get_cookie_data',
      bvModal,
      null,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/CookieDataModel.js